/**
 * Bridge to the native BatteryOptPlugin (Kotlin/Java) that returns whether
 * Carloo Tex is whitelisted from Android battery optimisation.
 *
 * On web / non-native runs returns ``{native: false}`` so the caller can show
 * a neutral indicator rather than a misleading "off" badge.
 */
import { registerPlugin, Capacitor } from '@capacitor/core';

const BatteryOpt = registerPlugin('BatteryOpt');

export async function getBatteryOptStatus() {
  if (!Capacitor?.isNativePlatform?.()) {
    return { native: false, ignored: null, manufacturer: '', model: '', sdk: 0 };
  }
  try {
    const r = await BatteryOpt.isIgnored();
    return {
      native: true,
      ignored: !!r.ignored,
      manufacturer: r.manufacturer || '',
      model: r.model || '',
      sdk: r.sdk || 0,
    };
  } catch (_) {
    return { native: true, ignored: null, manufacturer: '', model: '', sdk: 0 };
  }
}
